export class WorkAuthorizationVendorParametersDto {
    communityVendorId: number;
    locationVendorId: number;
    temporaryVendorId: number;
    communityId: number;
    workOrderId: number;
}
